const llStorage = {
  // Determine the storage to use based on the keepLoggedIn flag
  _chooseStorage: () => {
    // If "keepLoggedIn" flag in localStorage is set to 'true', use localStorage;
    // Otherwise, fall back to sessionStorage.
    
    //return localStorage.getItem('keepLoggedIn') === 'true' ? localStorage : sessionStorage;
    return localStorage;
  },
  getItem: (key) => {
    return llStorage._chooseStorage().getItem(key);
  },
  setItem: (key, value) => {
    return llStorage._chooseStorage().setItem(key, value);
  },
  removeItem: (key) => {
    return llStorage._chooseStorage().removeItem(key);
  }
};

export default llStorage;